import { useState } from "react";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle({ tid = "theme-toggle" }) {
  const [light, setLight] = useState(() => document.documentElement.classList.contains("light"));

  const toggle = () => {
    const next = !light;
    document.documentElement.classList.toggle("light", next);
    document.documentElement.classList.toggle("dark", !next);
    localStorage.setItem("hd-theme", next ? "light" : "dark");
    setLight(next);
  };

  return (
    <button type="button" data-testid={tid} onClick={toggle}
      title={light ? "Mudar para tema escuro" : "Mudar para tema claro"}
      className="text-zinc-400 hover:text-zinc-100 hover:bg-zinc-800 rounded-md p-1.5 transition-colors duration-200">
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
}
